import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=009bad45&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('009bad45')) {
      api.createRecord('009bad45', component.options)
    } else {
      api.reload('009bad45', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=009bad45&", function () {
      api.rerender('009bad45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2PhvwZAxDB47f/JS/comp/ErrorMessage.vue"
export default component.exports